import { BrowserRouter } from 'react-router-dom';
import AppContainer from "./App";
import { Provider } from 'react-redux';
import 'semantic-ui-css/semantic.min.css'
import './general.style.scss';
import React from 'react';
import { createRoot } from 'react-dom/client';
import store from "./store";

const root = createRoot(document.getElementById('root') as HTMLDivElement);

root.render(
        <Provider store={store}>
            <BrowserRouter>
                <AppContainer/>
            </BrowserRouter>
        </Provider>
);
